export const SAVE = 'step12.SAVE';
export const VALUE_CHANGED = 'step12.VALUE_CHANGED';
export const LOAD = 'step12.VALUE_LOAD';
export const UPLOAD_FILE = 'step12.UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'step12.UPLOAD_FILE_SUCCESS';
export const UPLOAD_PERCENTAGE = 'step12.UPLOAD_PERCENTAGE';
export const UPLOAD_PROGRESS_VISIBILITY = 'step12.UPLOAD_PROGRESS_VISIBILITY';
export const REMOVE_FILE = 'step12.REMOVE_FILE';
export const REMOVE_FILE_SUCCESS = 'step12.REMOVE_FILE_SUCCESS';
export const LOAD_CLAIM_ATTACHMENTS = 'step12.LOAD_CLAIM_ATTACHMENTS';
export const LOAD_CLAIM_ATTACHMENTS_SUCCESS = 'step12.LOAD_CLAIM_ATTACHMENTS_SUCCESS';
export const RESET = 'step12.RESET';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step12/constants.js